import { render, staticRenderFns } from "./DishSelectionNoCategories.vue?vue&type=template&id=720a2b1a&"
import script from "./DishSelectionNoCategories.vue?vue&type=script&lang=js&"
export * from "./DishSelectionNoCategories.vue?vue&type=script&lang=js&"
import style0 from "./DishSelectionNoCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports